import { Box, IconButton, Tooltip } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { ModalContext } from "./LosListe";

interface Props {
    children?: React.ReactNode
    icon?: React.ReactNode,
    title?: string,
    disabled?: boolean,
    setCheckedBoxes: Dispatch<SetStateAction<string[]>>
}

export default function BulkEditModal(props: Props) {

    const { children, icon, title = "Alle markierten Lose bearbeiten", disabled = false, setCheckedBoxes } = props
    const [modalOpened, setModalOpened] = useState(false);
    const [errorOpened, setErrorOpened] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    function handleErrorMessage(message: string | undefined) {
        setErrorMessage(message);
        setErrorOpened(!!message);
    }
    function handleOpen() {
        setModalOpened(true);
    }
    function handleClose(clearCheckboxes = false) {
        setModalOpened(false);
        if (clearCheckboxes && setCheckedBoxes) {
            setCheckedBoxes([]);
        }
    }

    return (
        <>
            <Box >
                <Tooltip title={title} placement="bottom">
                    <IconButton
                        sx={{
                            borderRadius: "100%",
                            width: "48px",
                            height: "48px",
                            justifyContent: "center",
                            backgroundColor: "#c0d904",
                            "&:hover": {
                                backgroundColor: "#869702",
                            },
                            "&:disabled": {
                                backgroundColor: "#c0d904",
                                opacity: 0.5,
                                cursor: "not-allowed",
                            },
                        }}
                        disabled={disabled}
                        onClick={handleOpen}>
                        {icon}
                    </IconButton>
                </Tooltip>
            </Box>
            <ModalContext.Provider value={{ handleOpen, modalOpened, handleClose, handleErrorMessage, errorMessage, errorOpened }}>
                {children}
            </ModalContext.Provider>
        </>

    )
}
